<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="#b03a2e">
                            <v-toolbar-title class="my-0 py-0">
                                REVISIÓN DE AUTOINSPECCIÓN DE PROCESOS (EI 057)
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            CÓDIGO: {{ codigo }} &nbsp;|&nbsp; REV: {{ revisionActual }}
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>

                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field color="red darken-3" label="Cliente" dense readonly
                                        v-model="clienteNombre"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="4">
                                    <v-text-field color="red darken-3" label="Obra" dense readonly
                                        v-model="obraNombre"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field color="red darken-3" label="N° de Obra" dense readonly
                                        v-model="numobra"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field color="red darken-3" label="Proceso" dense readonly
                                        v-model="proceso"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field color="red darken-3" label="Referencia" dense
                                        v-model="referencia"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field color="red darken-3" label="N° de OT" dense
                                        v-model="numot"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field color="red darken-3" label="Cantidad" dense
                                        v-model="cantidad" type="number" min="1"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card color="orange lighten-4">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12">
                                    <v-data-table :headers="headers" :items="listado" :items-per-page="200"
                                        hide-default-footer dense>
                                        <template v-slot:header.autoinsp>
                                            <div class="d-flex justify-center">
                                                <v-checkbox v-model="selectAll.autoinsp"
                                                    @change="toggleAll('autoinsp', selectAll.autoinsp)"
                                                    hide-details dense color="red" label="Autoinspección"></v-checkbox>
                                            </div>
                                        </template>
                                        <template v-slot:header.auditoria>
                                            <div class="d-flex justify-center">
                                                <v-checkbox v-model="selectAll.auditoria"
                                                    @change="toggleAll('auditoria', selectAll.auditoria)"
                                                    hide-details dense color="red" label="Auditoría"></v-checkbox>
                                            </div>
                                        </template>
                                        <template v-slot:item.autoinsp="{ item }">
                                            <div class="d-flex justify-center">
                                                <v-checkbox v-model="item.autoinsp" :true-value="true"
                                                    :false-value="false" @change="updateHeaderCheckbox('autoinsp')"
                                                    hide-details dense color="red"></v-checkbox>
                                            </div>
                                        </template>
                                        <template v-slot:item.auditoria="{ item }">
                                            <div class="d-flex justify-center">
                                                <v-checkbox v-model="item.auditoria" :true-value="true"
                                                    :false-value="false" @change="updateHeaderCheckbox('auditoria')"
                                                    hide-details dense color="red"></v-checkbox>
                                            </div>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field color="red darken-3" label="Aprobó especificación" dense
                                        v-model="aproboesp"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    <v-text-field color="red darken-3" label="Fecha" dense
                                        v-model="fechaesp"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field color="red darken-3" label="Aprobó inspección" dense
                                        v-model="aproboinsp"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    <v-text-field color="red darken-3" label="Fecha" dense
                                        v-model="fechainsp"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12">
                                    <v-text-field color="red darken-3" label="Observaciones" dense
                                        v-model="observ"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card color="#b03a2e" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="iniciarGuardado" :disabled="deshabilitar">
                                Guardar Revisión {{ revisionNueva }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>

                <!-- Dialog: Títulos de columnas cuando cantidad > 1 -->
                <v-dialog v-model="dialogTitulos" max-width="500px" persistent>
                    <v-card>
                        <v-toolbar dense dark color="#b03a2e">
                            <v-toolbar-title>Descripción de columnas</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text class="pt-4">
                            <p class="body-2 mb-3">
                                Ingresá el título para cada una de las <strong>{{ cantidad }}</strong> columnas:
                            </p>
                            <v-text-field v-for="(titulo, idx) in titulosColumnas" :key="idx"
                                v-model="titulosColumnas[idx]" :label="`Columna ${idx + 1}`"
                                color="red darken-3" dense outlined class="mb-1"></v-text-field>
                        </v-card-text>
                        <v-divider />
                        <v-card-actions>
                            <v-spacer />
                            <v-btn text color="grey darken-1" @click="dialogTitulos = false">Cancelar</v-btn>
                            <v-btn color="success" @click="confirmarGuardado">Continuar y Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

            </v-app>
        </div>
    </v-dialog>
</template>

<script>
import moment from "moment";
import axios from "../../../axios-auth";

export default {
    data: () => ({
        deshabilitar: false,
        valid: false,
        lazy: false,
        codigo: "",
        codgral: "",
        codreg: "",
        numcliente: "",
        numobraId: "",
        clienteNombre: "",
        obraNombre: "",
        numobra: "",
        proceso: "",
        referencia: "",
        numot: "",
        cantidad: "1",
        aproboesp: "",
        aproboinsp: "",
        fechaesp: "",
        fechainsp: "",
        observ: "",
        revisionActual: 0,
        listado: [],
        listadodetalle: [],
        selectAll: { autoinsp: false, auditoria: false },
        headers: [
            { text: "Item", align: "start", sortable: false, width: "10%", value: "item" },
            { text: "Autoinspección", value: "autoinsp", width: "15%", align: "center", sortable: false },
            { text: "Auditoría", value: "auditoria", align: "center", width: "15%", sortable: false },
            { text: "Característica", value: "caracteristica", width: "60%", align: "left", sortable: false },
        ],
        dialogTitulos: false,
        titulosColumnas: [],
    }),

    props: ["visible", "codint"],

    computed: {
        revisionNueva() {
            return this.revisionActual + 1;
        },
        show: {
            get() {
                if (this.visible) this.cargarDatos();
                return this.visible;
            },
            set(value) {
                if (!value) this.$emit("close");
            },
        },
    },

    methods: {
        toggleAll(campo, checked) {
            this.listado.forEach(item => { item[campo] = checked; });
        },
        isAllSelected(campo) {
            return this.listado.every(item => item[campo] === true);
        },
        updateHeaderCheckbox(campo) {
            this.selectAll[campo] = this.isAllSelected(campo);
        },

        cargarDatos() {
            if (!this.codint) return;
            axios.get("/Ingenieria/CargarEI057?", { params: { codint: this.codint } })
                .then((r) => {
                    this.codigo        = r.data.codigo;
                    this.codgral       = r.data.codgral;
                    this.codreg        = r.data.codreg;
                    this.numcliente    = r.data.numcliente;
                    this.numobraId     = r.data.numobra;
                    this.clienteNombre = r.data.cliente;
                    this.obraNombre    = r.data.obra;
                    this.numobra       = r.data.numobra;
                    this.proceso       = r.data.proceso;
                    this.referencia    = r.data.referencia;
                    this.numot         = r.data.numot;
                    this.cantidad      = r.data.cantidad;
                    this.aproboesp     = r.data.aproboesp;
                    this.fechaesp      = r.data.fechaesp;
                    this.aproboinsp    = r.data.aproboinsp;
                    this.fechainsp     = r.data.fechainsp;
                    this.observ        = r.data.observ;
                    this.revisionActual = Number(r.data.revision || r.data.Revision || 0);
                    this.titulosColumnas = (r.data.columnas || []).map(c => c.descr || c.Descr || c);
                    // Convertir detalles a booleanos para los checkboxes
                    this.listado = (r.data.detalles || []).map(d => ({
                        ...d,
                        autoinsp: d.autoinsp === true || d.autoinsp === "ON",
                        auditoria: d.auditoria === true || d.auditoria === "ON",
                    }));
                })
                .catch(() => { this.listado = []; });
        },

        iniciarGuardado() {
            const cant = parseInt(this.cantidad) || 1;
            if (cant > 1) {
                this.titulosColumnas = Array.from({ length: cant }, (_, i) =>
                    this.titulosColumnas[i] || ""
                );
                this.dialogTitulos = true;
            } else {
                this.guardar();
            }
        },

        confirmarGuardado() {
            if (this.titulosColumnas.some(t => !t || t.trim() === "")) {
                this.$swal({ icon: "warning", title: "Completá el título de todas las columnas",
                    toast: true, position: "top-end", showConfirmButton: false, timer: 3000 });
                return;
            }
            this.dialogTitulos = false;
            this.guardar();
        },

        guardar() {
            this.deshabilitar = true;
            this.$swal({
                title: "Guardar Revisión",
                text: `¿Desea guardar la Revisión ${this.revisionNueva}?`,
                icon: "question",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
            }).then((result) => {
                if (result.value) {
                    this.listadodetalle = [];
                    this.listado.forEach((element) => {
                        if (element.autoinsp || element.auditoria) {
                            this.listadodetalle.push({
                                codgral: this.codgral,
                                codreg:  this.codreg,
                                auditoria: element.auditoria,
                                autoinsp:  element.autoinsp,
                                renglon:   element.renglon,
                            });
                        }
                    });

                    const datos = {
                        codint:     this.codint,
                        codgral:    this.codgral,
                        codreg:     this.codreg,
                        numcliente: this.numcliente,
                        numobra:    this.numobraId,
                        cliente:    this.clienteNombre,
                        obra:       this.obraNombre,
                        proceso:    this.proceso,
                        referencia: this.referencia,
                        numot:      this.numot,
                        cantidad:   this.cantidad,
                        aproboesp:  this.aproboesp,
                        fechaesp:   this.fechaesp,
                        aproboinsp: this.aproboinsp,
                        fechainsp:  this.fechainsp,
                        observ:     this.observ,
                        revision:   this.revisionNueva,
                        columnas:   this.titulosColumnas.map((t, i) => ({ descr: t, numcolumna: String(i + 1) })),
                        detalles:   this.listadodetalle,
                    };

                    axios.post("/Ingenieria/GuardarRevisionEI057", datos)
                        .then(() => {
                            this.$swal.fire({ icon: "success", title: `Revisión ${this.revisionNueva} guardada con éxito`,
                                showConfirmButton: false, background: "#ececec", timer: 4000 });
                            this.vaciarListado();
                            this.$emit("close");
                        })
                        .catch(() => {
                            this.deshabilitar = false;
                        });
                } else {
                    this.deshabilitar = false;
                }
            });
        },

        vaciarListado() {
            this.deshabilitar  = false;
            this.codigo        = "";
            this.codgral       = "";
            this.codreg        = "";
            this.numcliente    = "";
            this.numobraId     = "";
            this.clienteNombre = "";
            this.obraNombre    = "";
            this.numobra       = "";
            this.proceso       = "";
            this.referencia    = "";
            this.numot         = "";
            this.cantidad      = "1";
            this.aproboesp     = "";
            this.aproboinsp    = "";
            this.fechaesp      = "";
            this.fechainsp     = "";
            this.observ        = "";
            this.revisionActual = 0;
            this.listado       = [];
            this.listadodetalle = [];
            this.titulosColumnas = [];
        },
    },
};
</script>
